import{DEFAULT_PALETTE as o}from"../../constants/colors.js";const n=(n,t,i)=>{let l=(null==n?void 0:n[0])||(null==t?void 0:t[0])||o;if(i){const o=[...n||[],...t||[]].find(o=>o.id===i);o&&(l=o)}return l};export{n as findPalette};
